export default ({ app }) => {
    if (process.client) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://accounts.google.com/gsi/client')
      script.setAttribute('async', true)
      script.setAttribute('defer', true)
      document.head.appendChild(script)
    }
  }
